export const convertTimestampToSeconds = (time) =>
  time.split(':').reduce(function (seconds, v) {
    return +v + seconds * 60;
  }, 0) / 60;
